export {H1, H2, H3, H4, H5, H6} from './Headings'
export {P, PSmall, PMedium, PLarge, PXLarge} from './Paragraphs'
export {default as CardTitle} from './CardTitle'
export {default as CardSubtitle} from './CardSubtitle'
export {default as PriceText, OldPriceText, DutyfreeText} from './PriceText'
